import { Link } from "react-router-dom";

//Styles
import { Image } from "./Thumb.styles";

const Thumb = ({ image, movieId, clickable = false }) => (
    <div>
        {clickable ? (
            <Link to={`movie/${movieId}`}>
                <Image src={image} alt="movie-thumb" />
            </Link>
        ) : (
            <Image src={image} alt="movie-thumb" />
        )}
    </div>
);

export default Thumb;
